import './components/offcanvas'
import './components/insights'
import './vendors/bootstrap.min'
import './vendors/jquery.magnific-popup.min'
import $ from 'jquery';

$('.gallery-link').each(function() {
	$(this).magnificPopup({
		delegate: 'a',
		type: 'image',
		gallery: {
			enabled: true
		}
	});
});